import Index from '../components/Import/Index';

let routes = {
    path: '/import',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/import',
            component: Index
        }
    ]
}

export default routes;


// WEBPACK FOOTER //
// ./src/router/import.js